import styled, { css } from "styled-components";

import colors from "core/colors";
import breakpoints from "core/breakpoints";
import Heading from "core/Heading";
import BodyText from "core/BodyText";
import Button from "core/Button";

import { convertPxToRem } from "frontend/components/helpers";
import { getButtonTextAlignment } from "./helpers";

export const CardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: ${({ cardBoxesAlignment }) => cardBoxesAlignment};

    // tablet and desktop:
    @media (min-width: ${breakpoints.tablet.rem}) {
        flex-direction: row;
    }
`;

export const IconContainer = styled.div`
    svg {
        margin-right: ${convertPxToRem({ px: 16 })};

        &:last-of-type {
            margin-right: 0;
        }
    }
`;

export const StyledHeading = styled(Heading)``;

export const StyledBodyText = styled(BodyText)``;

export const PriceContainer = styled.div`
    margin-bottom: ${convertPxToRem({ px: 34 })};
`;

export const StyledPriceSubheading = styled(BodyText)`
    margin-top: ${convertPxToRem({ px: 9 })};
    height: ${convertPxToRem({ px: 22 })};
`;

export const StyledPriceHeading = styled(Heading)`
    display: inline-flex;
    text-align: ${({ cardContentAlignment }) => cardContentAlignment};
    align-items: center;
    height: ${convertPxToRem({ px: 39 })};
`;

export const StyledDurationBodyText = styled(BodyText)``;

export const StyledButton = styled(Button)`
    ${({ cardContentAlignment }) =>
        getButtonTextAlignment({ cardContentAlignment })};
`;

export const Card = styled.div`
    width: 100%;
    text-align: ${({ cardContentAlignment }) => cardContentAlignment};
    border: ${convertPxToRem({ px: 1 })} solid ${colors.primary.scheifer};
    padding: ${convertPxToRem({ px: 48 })} ${convertPxToRem({ px: 8 })};
    margin: ${convertPxToRem({ px: 10 })} 0;

    &:first-of-type {
        margin-top: 0;
    }

    &:last-of-type {
        margin-bottom: 0;
    }

    ${IconContainer},
    ${StyledHeading},
    ${StyledBodyText} {
        margin-bottom: ${convertPxToRem({ px: 24 })};
    }

    // tablet and desktop:
    @media (min-width: ${breakpoints.tablet.rem}) {
        width: ${convertPxToRem({ px: 338 })};
        padding: ${convertPxToRem({ px: 48 })} ${convertPxToRem({ px: 30 })};
        margin: 0 ${convertPxToRem({ px: 10 })};

        &:first-of-type {
            margin-left: 0;
        }

        &:last-of-type {
            margin-right: 0;
        }
    }
`;
